module.exports = __webpack_public_path__ + "static/media/icon.ecffd003.svg";